import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IOrganization } from '../../../types/contactModule';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { CsvServiceService } from '../../../services/csv/csv-service.service';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';
import { formatCount } from '../../../../utils/sms';

/** Adds organizations to rows of an import before they are saved (local only). */
@Component({
  selector: 'csv-assign-multiple-contacts-to-organizations',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './csv-assign-multiple-contacts-to-organizations.component.html',
  styleUrls: [
    '../../organization/contacts/group-picker/group-modal.css',
    './csv-assign-multiple-contacts-to-organizations.component.css',
  ],
})
export class CsvAssignMultipleContactsToOrganizationsComponent implements OnChanges {
  @Input({ required: true }) open: boolean = false;
  @Input() selectedContactsIndexes: (string | number)[] = [];
  @Input() selection: IOrganization[] = [];
  @Output() resetSelectedContactsIndexes = new EventEmitter();
  @Output() close = new EventEmitter();

  // services
  contactService = inject(ContactsService);
  csvService = inject(CsvServiceService);

  selectedOrganizations: IOrganization[] = [];
  showModal: boolean = false;

  get rowLabel(): string {
    const count = this.selectedContactsIndexes?.length ?? 0;
    return count === 1 ? '1 row' : `${formatCount(count)} rows`;
  }

  get submitLabel(): string {
    const count = this.selectedOrganizations.length;
    if (!count) return 'Choose organizations';
    return count === 1 ? 'Add to 1 organization' : `Add to ${count} organizations`;
  }

  onPick(items: any[]) {
    this.selectedOrganizations = items as IOrganization[];
  }

  handleSubmit() {
    if (!this.selectedOrganizations.length) return;
    this.csvService.assignSelectedOrganizationsToSelectedContacts(
      this.selectedContactsIndexes,
      this.selectedOrganizations
    );
    this.resetSelectedContactsIndexes.emit();
    this.closeModal();
  }

  closeModal() {
    this.close.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.selectedOrganizations = [...(this.selection ?? [])];
    }
    this.showModal = this.open;
  }
}
